import React from 'react';
import { Trans } from 'react-i18next';

import './index.scss';
import silvia from '../../assets/silvia.png';
import maria from '../../assets/maria.png';


export const AboutUsSection = () => {
    return <div className='row  mx-0 about-us-section'>
        <h2>Silvia</h2>
        <div className='row p-0 m-0 flex-column-reverse flex-md-row'>
            <div className='col-lg-8 col-md-12 pt-5 pe-lg-5'>
                <p>
                    <Trans 
                        i18nKey='aboutUsPage.aboutUsSection.silvia.firstParagraph'
                        components={{
                            bold: <b />
                        }}
                    />
                </p>
                <p className='mt-5'>
                    <Trans 
                        i18nKey='aboutUsPage.aboutUsSection.silvia.secondParagraph'
                        components={{
                            bold: <b />
                        }}
                    />
                </p>
                <div className='highlighted-paragraph'>
                    <p className='mt-5'>
                        <Trans 
                            i18nKey='aboutUsPage.aboutUsSection.silvia.thirdParagraph'
                            components={{
                                bold: <b />
                            }}
                        />
                    </p>
                </div>
            </div>
            <div className='col-lg-4 col-md-12 pt-5'>
                <img src={silvia} alt='lezioni di Spagnolo con Silvia' width='100%' />
            </div>
        </div>
        <div className='row'>
            <p className='mt-5'>
                <Trans 
                    i18nKey='aboutUsPage.aboutUsSection.silvia.fourthParagraph'
                    components={{
                        bold: <b />
                    }}
                />
            </p>
        </div>
        <hr className='mt-5 mb-5' />
        <h2>María José</h2>
        <div className='row p-0 m-0 flex-md-row'>
            <div className='col-lg-4 col-md-12 pt-5'>
                <img src={maria} alt='lezioni di Spagnolo con Silvia' width='100%' />
            </div>
            <div className='col-lg-8 col-md-12 pt-5 pe-lg-5'>
                <p>
                    <Trans 
                        i18nKey='aboutUsPage.aboutUsSection.maria.firstParagraph'
                        components={{
                            bold: <b />
                        }}
                    />
                </p>
                <p className='mt-5'>
                    <Trans 
                        i18nKey='aboutUsPage.aboutUsSection.maria.secondParagraph'
                        components={{
                            bold: <b />
                        }}
                    />
                </p>
                <p className='mt-5'>
                    <Trans 
                        i18nKey='aboutUsPage.aboutUsSection.maria.thirdParagraph'
                        components={{
                            bold: <b />
                        }}
                    />
                </p>
                <p className='mt-5'>
                    <Trans 
                        i18nKey='aboutUsPage.aboutUsSection.maria.fourthParagraph'
                        components={{
                            bold: <b />
                        }}
                    />
                </p>
            </div>
        </div>
        <div className='row'>
            <p className='highlighted-paragraph  mt-5'>
                <Trans 
                    i18nKey='aboutUsPage.aboutUsSection.maria.fifthParagraph'
                    components={{
                        bold: <b />
                    }}
                />
            </p>
            <p className='mt-3'>
                <Trans 
                    i18nKey='aboutUsPage.aboutUsSection.maria.sixthParagraph'
                    components={{
                        bold: <b />
                    }}
                />
            </p>
        </div>
    </div>
}

export default AboutUsSection;